module.exports = __webpack_public_path__ + "static/img/07_pro.20b911a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/07_pro.jpg
// module id = gM6p
// module chunks = 0